import { render } from "./OldPortfolio.vue?vue&type=template&id=29f9cdc0&scoped=true"
import script from "./OldPortfolio.vue?vue&type=script&lang=js"
export * from "./OldPortfolio.vue?vue&type=script&lang=js"

import "./OldPortfolio.vue?vue&type=style&index=0&id=29f9cdc0&scoped=true&lang=css"

import exportComponent from "/opt/render/project/src/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-29f9cdc0"]])

export default __exports__